import React, { useContext, useEffect, useState } from "react";
// import styles from './style.module.css';
import { AuthContext } from "../../authContext";
import useStore from "../../store/store";
import serverPath from "../../utils/serverPath";
import { NavLink, useNavigate  } from "react-router-dom";
import SweetAlert from "../../Components/SweetAlert";
import CurrencyArranger from "../../utils/CurrencyArranger";

const CreateCurrencyRate = (props) =>
{
    const context = useContext(AuthContext);
    const [globalState, dispatch] = useStore();
    const [tableExport, setTableExport] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const {currencyRates, currencies} = globalState;
    const initialFields = {
      currencyRates: [{id: 1, buy: 0.00, sell: 0.00, province: "Kabul"}],
      fromCurrency: currencies[1]?.id,
      toCurrency: currencies[0]?.id,
      toCurrencies: [],
    };
    const [fields, setFields] = useState({...initialFields});
    let provinces = ["Kabul", "Kandahar", "Herat", "Mazar-i-Sharif", "Jalalabad"];

    useEffect(() =>
    {
      currencyRatesMaker();
    }, []);

    useEffect(() =>
    {
      let currency = globalState.currencies.find(curr => curr.id === fields.fromCurrency);
      const moreCurrency = CurrencyArranger.find(per => per.parentCurrency === currency?.code);
      let childCurrencies = [];
      moreCurrency?.children?.forEach(element => {
        const isCurrencyExist = globalState.currencies.find(curr => curr?.code === element);
        if (isCurrencyExist)
          childCurrencies.push(isCurrencyExist);
      });
      // changeHandler(childCurrencies, "toCurrencies")
      // changeHandler(childCurrencies[0]?.id, "toCurrency");
      setFields(prev => ({...prev, toCurrencies: childCurrencies, toCurrency: childCurrencies[0]?.id}));
    }, [fields.fromCurrency]);

    const currencyRatesMaker = () =>
    {
      let newProvinces = [];
      for (let i = 1; i <= provinces.length; i++)
      {        
        newProvinces.push({id: i, buy: 0.00, sell: 0.00, province: provinces[i-1]});
      }
      changeHandler(newProvinces, "currencyRates");
    }

    const submitHandler = async (e) =>
    {
      if(isLoading)
        return;

      e.preventDefault();

      if (Number.parseInt(fields.fromCurrency) === Number.parseInt(fields.toCurrency))
          return SweetAlert("warning", `Please change one currency in From Currency or To Currency`);

      const currencyRatesClone = [...fields.currencyRates];
      let hasValidRate = false;
      for (let rate of currencyRatesClone) 
      {
        const { buy, sell, province } = rate;

        if ((buy === 0 && sell === 0) || (!buy && !sell)) continue;

        if ((buy > 0 && (!sell || sell === 0)) || (sell > 0 && (!buy || buy === 0)))
          return SweetAlert("warning", `Apply condition for ${province}`);

        if (buy > 0 && sell > 0)
          hasValidRate = true;
      }
      if (!hasValidRate)
        return SweetAlert("warning", "At least one province must have both buy and sell.");
        
      const newCurrencyRates = fields.currencyRates
        .filter(rate => rate.buy > 0 && rate.sell > 0)
        .map(({ id, ...rest }) => rest);

      try {
        setIsLoading(true);
        
        const {data, status, message} = await (await fetch(serverPath("/currency_rate"), {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${localStorage.getItem("A_TOKEN")}`
          },
          body: JSON.stringify({fromCurrencyId: fields.fromCurrency, toCurrencyId: fields.toCurrency, rates: newCurrencyRates})
        })).json();

        if(status === "failure")
          SweetAlert("warning", message)
          
        if(status === "success")
        {
          currencyRatesMaker();
          SweetAlert("success", "Currency Rates are successfully added.");
          dispatch('setData', {type: 'currencyRates', data: [...currencyRates, ...data]});         
        }
      } catch (error) {
          SweetAlert("warning", error.message)
      }
      setIsLoading(false);
    }

    const changeHandler = (value, type, id) =>
    {
      if (id)
      {
        const cloneCurrencyRates = [...fields.currencyRates];
        const finded = cloneCurrencyRates.find(per => per.id === id);
        if (type === "buy")
          finded.buy = value
        else if (type === "sell")
          finded.sell = value

        setFields(prev => ({...prev, "currencyRates": cloneCurrencyRates}));
        return;
      }
      setFields(prev => ({...prev, [type]: value}));
    }

//   const autoGenerateRates = async (times = 50) => {
//     const provinces = ["Kabul", "Kandahar", "Herat", "Mazar-i-Sharif", "Jalalabad"];
//     const fromCurrencyId = currencies[0]?.id;
//     const toCurrencyId = currencies[2]?.id || currencies[0]?.id;

//     if (!fromCurrencyId || !toCurrencyId || fromCurrencyId === toCurrencyId) {
//       console.warn("Currencies not properly set.");
//       return;
//     }

//     for (let i = 0; i < times; i++) {
//       const rates = provinces.map(province => ({
//         buy: (Math.random() * 100).toFixed(2),
//         sell: (Math.random() * 100).toFixed(2),
//         province,
//       }));

//     const body = {
//       fromCurrencyId,
//       toCurrencyId,
//       rates,
//     };

//     try {
//       const res = await fetch(serverPath("/currency_rate"), {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           "Authorization": `bearer ${localStorage.getItem("A_TOKEN")}`
//         },
//         body: JSON.stringify(body),
//       });

//       const result = await res.json();

//       if (result.status === "success") {
//         console.log(`✅ Batch ${i + 1} inserted`);
//       } else {
//         console.warn(`⚠️ Batch ${i + 1} failed:`, result.message);
//       }
//     } catch (err) {
//       console.error(`❌ Error in batch ${i + 1}:`, err.message);
//     }
//   }
// };
    
    return (
      <div className="main-content">
        <section className="section">
          <div className="section-body">
            <div className="row">
              <div className="col-12">
                <div className="card">
                  <form onSubmit={submitHandler}>
                  <div className="card-header">
                    <h4>Create You Currency Rate</h4>
                  </div>
                  {/* <button className={["btn btn-primary", isLoading ? "btn-progress" : ""].join(" ")} type="button" onClick={() =>  autoGenerateRates(100)} disabled={isLoading}>Send</button> */}
                  <div className="card-body row">
                    <div className="form-group col-lg-4 col-md-6 col-12">
                      <div className="row">
                        <div className="col-11">
                          <label>From Currency</label>
                          <select className="form-control" value={fields.fromCurrency} onChange={({target}) => changeHandler(Number.parseInt(target.value), "fromCurrency")}>
                            {globalState.currencies.map(currency => (
                              <option value={currency.id} key={currency.id}>{currency?.code}</option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="form-group col-lg-4 col-md-6 col-12">
                      <div className="row">
                        <div className="col-11">
                          <label>To Currency</label>
                           <select className="form-control" value={fields.toCurrency} onChange={({target}) => changeHandler(Number.parseInt(target.value), "toCurrency")}>
                            {
                              fields.toCurrencies.map((currency, index) => (
                                <option value={currency.id} key={currency.id}>{currency?.code}</option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                  {
                    fields.currencyRates?.map((value, index) => (
                      <div className="card-body row" key={value.id}>
                        <div className="form-group col-lg-4 col-md-6 col-12">
                          <div className="row">
                            <div className="col-11">
                              <label>Buy</label>
                              <input type="number" className="form-control" value={value.buy} onChange={({target}) => changeHandler(target.value, "buy", value.id)} min={0} step="0.00001"/>
                            </div>
                          </div>
                        </div>
                        <div className="form-group col-lg-4 col-md-6 col-12">
                          <div className="row">
                            <div className="col-11">
                              <label>Sell</label>
                              <input type="number" className="form-control" value={value.sell} onChange={({target}) => changeHandler(target.value, "sell", value.id)} min={0} step="0.00001"/>
                            </div>
                          </div>
                        </div>
                        <div className="form-group col-lg-4 col-md-6 col-12">
                          <div className="row">
                            <div className="col-11">
                              <label>Province</label>
                              <input type="text" className="form-control" value={value.province} onChange={({target}) => {}} disabled={true}/>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                  }
                  
                  <div className="card-footer text-left">
                    <button className={["btn btn-primary", isLoading ? "btn-progress" : ""].join(" ")} type="submit" disabled={isLoading}>Submit</button>
                  </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    )
}


export default CreateCurrencyRate;